import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HeadClothingManualExtensionPayload } from '../models/clothing.model';

@Component({
  selector: 'app-clothing-head-extension-modal',
  templateUrl: './clothing-head-extension-modal.component.html',
  styleUrls: ['./clothing-head-extension-modal.component.css']
})
export class ClothingHeadExtensionModalComponent {
  public itemName = '';
  public workingDays = 1;
  public reason = '';

  constructor(public activeModal: NgbActiveModal) {}

  setValues(itemName: string): void {
    this.itemName = itemName;
  }

  confirm(): void {
    if (!this.isFormValid()) {
      return;
    }
    this.activeModal.close(this.createPayload());
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  isFormValid(): boolean {
    return this.isWorkingDaysValid() && this.isReasonValid();
  }

  isWorkingDaysValid(): boolean {
    return this.workingDays >= 1;
  }

  isReasonValid(): boolean {
    return !!this.reason && !!this.reason.trim().length;
  }

  private createPayload(): HeadClothingManualExtensionPayload {
    return {
      workingDays: this.workingDays,
      reason: this.reason.trim()
    };
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/clothing-head-extension-modal.component.ts